import * as Yup from 'yup'

export const NEW_TICKET_SCHEMA = Yup.object().shape({
  category: Yup.string().required('Please select category'),
  subject: Yup.string().required('Please enter subject').min(4, 'Please enter valid subject'),
  message: Yup.string().required('Please enter message').min(4, 'Please enter valid message'),
  attachments: Yup.array(),
})
